var _rect, _rect2, _rect3, _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 0.129181,
    width: 3,
    height: 2,
    rx: 1,
    transform: "rotate(90 11 0.129181)",
    fill: "#1847CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4.12918,
    width: 3,
    height: 2,
    rx: 1,
    transform: "rotate(30 1 4.12918)",
    fill: "#1847CA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    rx: 1,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 18.5981 4.12918)",
    fill: "#1847CA"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16.7699C15.7725 15.5074 16.9286 13.4354 16.9286 11.0935C16.9286 7.2472 13.8106 4.12918 9.96429 4.12918C6.11802 4.12918 3 7.2472 3 11.0935C3 13.4668 4.18714 15.5628 6 16.8201V19.1292H14V16.7699Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.7699L12.8397 15.1409L12 15.739V16.7699H14ZM6 16.8201H8V15.7733L7.13981 15.1767L6 16.8201ZM6 19.1292H4V21.1292H6V19.1292ZM14 19.1292V21.1292H16V19.1292H14ZM14.9286 11.0935C14.9286 12.7613 14.108 14.2375 12.8397 15.1409L15.1603 18.3989C17.4371 16.7773 18.9286 14.1096 18.9286 11.0935H14.9286ZM9.96429 6.12918C12.706 6.12918 14.9286 8.35177 14.9286 11.0935H18.9286C18.9286 6.14263 14.9151 2.12918 9.96429 2.12918V6.12918ZM5 11.0935C5 8.35177 7.22259 6.12918 9.96429 6.12918V2.12918C5.01345 2.12918 1 6.14263 1 11.0935H5ZM7.13981 15.1767C5.84266 14.277 5 12.7835 5 11.0935H1C1 14.1501 2.53163 16.8485 4.86019 18.4635L7.13981 15.1767ZM8 19.1292V16.8201H4V19.1292H8ZM14 17.1292H6V21.1292H14V17.1292ZM12 16.7699V19.1292H16V16.7699H12Z",
    fill: "#1847CA",
    mask: "url(#path-4-inside-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.1292H13V20.1292C13 20.6815 12.5523 21.1292 12 21.1292H8C7.44772 21.1292 7 20.6815 7 20.1292V18.1292Z",
    stroke: "#1847CA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSmall);
export default __webpack_public_path__ + "static/media/help-small.71eae90d60e3a4ed6680e86aac38879b.svg";
export { ForwardRef as ReactComponent };